import React from 'react';

export default function CallCenterIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_135_2139)">
        <path d="M12 .03C7.197.03 3.15 3.357 1.846 7.903.681 8.606 0 9.957 0 11.54c0 2.294 1.398 4.154 3.692 4.154a.923.923 0 00.923-.923V8.308c0-.424-.301-.757-.692-.865C5.271 4.136 8.382 1.819 12 1.819c3.618 0 6.73 2.317 8.077 5.624-.39.108-.692.44-.692.865v6.462a.923.923 0 00.923.923c.215 0 .407-.026.605-.058-.298 1.722-1.022 3.006-1.76 3.895a6.777 6.777 0 01-1.297 1.211 3.186 3.186 0 01-.433.26c-.053.025-.098.05-.115.058h-1.731c-.332-.966-1.39-1.674-2.654-1.674-1.53 0-2.77 1.034-2.77 2.308 0 1.274 1.24 2.308 2.77 2.308 1.264 0 2.322-.71 2.654-1.674h1.818c.311 0 .39-.083.576-.173.185-.09.404-.213.634-.374a7.996 7.996 0 001.559-1.443c.973-1.172 1.88-2.912 2.105-5.25C23.36 14.364 24 13.065 24 11.54c0-1.582-.681-2.932-1.846-3.635C20.85 3.358 16.803.03 12 .03z" />
      </g>
      <defs>
        <clipPath id="clip0_135_2139">
          <path d="M0 0H24V24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
